import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

export const inviteAtom = atomWithStorage(
  'invite',
  sessionStorage.getItem('invite'),
  sessionStorage
);

export const inviteCodeAtom = atom((get) => {
  const invite = get(inviteAtom);
  if (!invite) return undefined;

  try {
    const { code } = JSON.parse(invite);
    return code;
  } catch (e) {
    return undefined;
  }
});

export const inviteEmailAtom = atom((get) => {
  const invite = get(inviteAtom);
  if (!invite) return undefined;

  try {
    const { email } = JSON.parse(invite);
    return email;
  } catch (e) {
    return undefined;
  }
});

export const inviteTeamAtom = atom((get) => {
  const invite = get(inviteAtom);
  if (!invite) return undefined;

  try {
    const { team } = JSON.parse(invite);
    return team;
  } catch (e) {
    return undefined;
  }
});
